import React from "react";
import { Link } from 'react-scroll';

export default function Services() {
  const services = [
    {
      img: "service_coordination.jpg",
      title: "Wedding Day Coordination",
      desc: "The ideal package for the couple who has everything planned and just need someone to take care of the remaining details leading up to the big day. We step in three months before to tie all loose ends together with a wedding day checklist, detailed timeline, and vendor coordination. Upon hiring, I will be available by phone or email as a consultant for your wedding planning.",
    },
    {
      img: "service_partial.jpg",
      title: "Partial Planning",
      desc: "The perfect package for the busy couple who semi-know what they want their wedding to look like, but just don't have time to plan everything on their own! We step in halfway through the wedding planning process after the main vendors are booked and assist with advising you on the best methods to achieve your unique ideas for your wedding day.",
    },
    {
      img: "service_full.jpg",
      title: "Full Planning",
      desc: "The complete package for the couple who just got engaged and have no idea where to start, or simply don't want to stress over wedding planning details on their own. We guide you throughout the entire wedding planning process from conception to execution. We've got you covered from the beginning to the end.",
    },
  ];

  return (
    <div id="services" className="min-h-screen relative py-16">
      <div className="w-11/12 sm:w-10/12 md:w-8/12 flex flex-col mx-auto">
        {/* Service cards — stacked on mobile, row on md+ */}
        <div className="flex flex-col md:flex-row gap-8 md:gap-3">
          {services.map(({ img, title, desc }) => (
            <div key={title} className="w-full md:w-4/12 flex">
              <div className="text-primary w-full">
                <div
                  className="h-64 md:h-80 bg-cover bg-center"
                  style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/${img})` }}
                />
                <div>
                  <div className="mt-3 mb-3.5 text-center">
                    <span>{title}</span>
                  </div>
                  <div className="text-center">
                    <span className="text-xs">{desc}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Ala Carte section */}
        <div className="text-primary mt-10">
          <div className="text-center mb-4">
            <span>Ala Carte &amp; Special Events</span>
          </div>
          <div className="mb-8 text-center">
            <span className="text-xs">Don't see a package that best fits your needs? We offer customized packages that are unique to the needs of your events. Inquire to learn more!</span>
          </div>
          <div className="w-full flex justify-center">
            <Link to="contact" smooth={true} offset={-75}>
              <button className="inline-flex mx-auto bg-button py-4 px-8 rounded-full">
                <span className="uppercase text-primary text-xs">
                  Inquire Now
                </span>
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}